import { render } from "./SellerFilterItem.vue?vue&type=template&id=5a84e2c6&scoped=true"
import script from "./SellerFilterItem.vue?vue&type=script&lang=js"
export * from "./SellerFilterItem.vue?vue&type=script&lang=js"

import "./SellerFilterItem.vue?vue&type=style&index=0&id=5a84e2c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a84e2c6"]])

export default __exports__